/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyForgePioGoogleDriveIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-google-drive-dev" */ './utils').then(
			(m) => m.ForgePioGoogleDriveIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-google-drive-dev/icon' },
);

const LazyForgePioGoogleDriveSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-google-drive-dev-search-result" */ './utils').then(
			(m) => m.ForgePioGoogleDriveSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-google-drive-dev/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgePioGoogleDriveIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgePioGoogleDriveIconComponent />
	</Suspense>
);

export const ForgePioGoogleDriveSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgePioGoogleDriveSearchResultIconComponent />
	</Suspense>
);
